import { db } from '../firebase'
/* eslint-disable no-unused-vars */
import { collection, doc, setDoc, addDoc, getDoc, getDocs, deleteDoc, arrayUnion, arrayRemove, updateDoc } from "firebase/firestore";
const axios = require('axios');
import { VueCookieNext } from 'vue-cookie-next'
import helpers from '@trust/helpers'

const state = {
  baseTenantUrl: '/api/v1/tenant',
  name: 'Loading',
  numberPrefix: '...',
  piping: {},
  arenaPipeErrorMessage: null,
   conceptsCollection: 'concepts',
   blocksCollection: 'blocks',
   arenaStreams: {
     paragonday: {
       channelSlug: 'paragonday',
       blocksPageNum: 0,
       blocks: [],
     },
     timetable: {
       channelSlug: 'paragonday-timetable',
       blocksPageNum: 0,
       blocks: [],
     },
     timekeeper: {
       channelSlug: 'paragonday-time-keeper',
       blocksPageNum: 0,
       blocks: [],
     },
   },
   alphabet: [
     'A',
     'B',
     'C',
     'D',
     'E'
   ],
   concepts: [],
   allConcepts: [],
   blocks: [],
   allBlocks: [],
   removingStatus: null,
   userTrusts: [],
   activeTrust: null,
   users: [],
   teamErrorMessage: null,
   fetchedConcepts: false,
};
const getters = {
};
const actions = {
  async removeBlock(context, { blockId, conceptId }){
    try {
      context.commit('setRemovingStatus', { status: 'removing' });
      let response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/block/remove', { blockId, conceptId });
      console.log('removeBlock success');
      // console.log('new concept: ', response)
      context.commit('fetchConcepts');
      context.commit('fetchBlocks');
      context.commit('setRemovingStatus', { status: 'done' });

    } catch (error) {
      console.log('removeBlock error', error)
    }
  },

  async fetchTrustMeta(context) {
    try {
      let response = await helpers.callServer('POST', state.activeTrust, '/api/v1/connect/tenant/meta');
      let trustName = response.data.trustName;
      let numberPrefix = response.data.numberPrefix;
      let piping = response.data.piping;
      context.commit('setTrustName', { trustName });
      context.commit('setNumberPrefix', { numberPrefix });
      if(piping != undefined){
        context.commit('setPiping', { piping });
      }
    } catch (error) { console.log(error) }
  },

  async fetchUserTrusts(context) {
    try {
      console.log('fetching all trusts for: ', context.rootState.walletConnect.user.displayAddress)
      let response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/trusts', { wallet:  context.rootState.walletConnect.user.displayAddress });
      let { trusts, activeTrust } = response.data;
      console.log(trusts)

      context.commit('saveTrusts', { trusts });
      context.commit('setActiveTrust', { activeTrust });

    } catch (error) { console.log(error) }
  },

  async fetchUser(context) {
    try {
      console.log('fetching user data: ', context.rootState.walletConnect.user.displayAddress)
      let response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/user', { wallet:  context.rootState.walletConnect.user.displayAddress });
      let { role, permissions } = response.data.user;

      context.commit('setUserRole', role);
      context.commit('setUserPermissions', permissions);

    } catch (error) { console.log(error) }
  },

  async fetchUsers(context) {
    try {
      let response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/users');
      let { users } = response.data;

      context.commit('setUsers', users);

    } catch (error) { console.log(error) }
  },

  async fetchBlock(context, block) {
    try {
      let response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/block', { blockId: block._id });
      let newBlock = response.data.block;
      context.commit('setBlock', { newBlock });

    } catch (error) { console.log(error) }
  },

  async removeUser(context, {userId}) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/user/remove', { userId });
      context.dispatch('fetchUsers')
    } catch(err){
      console.error(err)
      context.commit('setTeamErrorMessage', {message: err})
    }
  },

  async addUser(context, {userWallet, permissions}) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/user/admin/add', { wallet: userWallet, permissions });
      context.dispatch('fetchUsers')
    } catch(err){
      console.error(err)
      context.commit('setTeamErrorMessage', {message: err})
    }
  },

  async makeAdmin(context, {userId}) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/user/admin/makeAdmin', { userId });
      context.dispatch('fetchUsers')
    } catch(err){
      console.error(err)
      context.commit('setTeamErrorMessage', {message: err})
    }
  },

  async revokeAdmin(context, {userId}) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/user/admin/revokeAdmin', { userId });
      context.dispatch('fetchUsers')
    } catch(err){
      console.error(err)
      context.commit('setTeamErrorMessage', {message: err})
    }
  },

  async setPermissions(context, {userId, permissions}) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/user/admin/setPermissions', { userId, permissions });
      context.dispatch('fetchUsers')
    } catch(err){
      console.error(err)
      context.commit('setTeamErrorMessage', {message: err})
    }
  },

  async addConceptPermission(context, {userId, conceptId}) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/user/admin/addConceptPermission', { userId, conceptId });
      context.dispatch('fetchUsers')
    } catch(err){
      console.error(err)
      context.commit('setTeamErrorMessage', {message: err})
    }
  },

  async removeConceptPermission(context, {userId, conceptId}) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/user/admin/removeConceptPermission', { userId, conceptId });
      context.dispatch('fetchUsers')
    } catch(err){
      console.error(err)
      context.commit('setTeamErrorMessage', {message: err})
    }
  },

  async updateArenaPipe(context, { on }) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/meta/admin/pipe/arena', { on });
      context.dispatch('fetchTrustMeta')
    } catch(err){
      console.error(err)
      context.commit('setArenaPipeErrorMessage', {message: err})
    }
  },

  async updateArenaPipeChannels(context, { newIdeaChannel, newReferenceChannel }) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/meta/admin/pipe/arena/channels', { newIdeaChannel, newReferenceChannel });
      context.dispatch('fetchTrustMeta')
    } catch(err){
      console.error(err)
      context.commit('setArenaPipeErrorMessage', {message: err})
    }
  },


};
const mutations = {
  setRemovingStatus(state, { status }) {
    state.removingStatus = status;
  },

  setTrustName(state, { trustName }) {
    state.name = trustName;
  },

  setNumberPrefix(state, { numberPrefix }) {
    state.numberPrefix = numberPrefix;
  },

  setPiping(state, { piping }) {
    state.piping = piping;
  },

  saveTrusts(state, { trusts }) {
    state.userTrusts = trusts;
  },
  setActiveTrust(state, { activeTrust }) {
    state.activeTrust = activeTrust;
  },

  setUsers(state, users) {
    state.users = users;
  },

  setTeamErrorMessage(state, {message}) {
    state.teamErrorMessage = message;
  },

  setArenaPipeErrorMessage(state, {message}) {
    state.arenaPipeErrorMessage = message;
  },

  setBlock(state, { newBlock }) {
    for(let i = 0; i < state.blocks.length; i++){
      if(state.blocks[i]._id == newBlock._id){
        state.blocks[i] = newBlock;
        return;
      }
    }
  },

  async fetchNextBlocks(state, { channel, fetchAll }) {
    // console.log('fetching page ' + state.arenaStreams[channel].blocksPageNum + ' for ' + channel);

    const response = await axios.get('/arena/blocks', {
      params: {
        channelSlug: state.arenaStreams[channel].channelSlug,
        page: state.arenaStreams[channel].blocksPageNum,
        getAllBlocks: fetchAll || false
      }
    });

    let { blocksContent } = response.data;
    state.arenaStreams[channel].blocks = state.arenaStreams[channel].blocks.concat(blocksContent);

    state.arenaStreams[channel].blocks.sort(function(a, b) {
      var keyA = a.position,
          keyB = b.position;
      // Compare the 2 orders
      if (keyA > keyB) return -1;
      if (keyA < keyB) return 1;
      return 0;
    });

    state.arenaStreams[channel].blocksPageNum++;
  },

  async createConcept(state, { newConceptName }) {
    try {
      let response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/concepts/create', { name: newConceptName });
      // console.log('new concept: ', response)
      let concept = response.data.concept;
      state.concepts.push(concept);

    } catch (error) { console.log(error) }
  },

  async connectToConcept(state, { blockId, conceptId }) {
    try {
      let concept = state.concepts.find(concept => concept.id == conceptId);

      let blockInConcept = {
        order: concept.blocks.length,
        blockId: blockId
      }

      const conceptDocRef = await updateDoc(doc(db, state.conceptsCollection, conceptId), {
        blocks: arrayUnion(blockInConcept),
      });

      // state.concepts.push({ id: subjectDocRef.id, name: newSubjectName})
      // console.log("Concept Document updated with blocks");

    } catch (error) { console.log(error) }
  },

  async fetchConcepts (state) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/concepts');
      // console.log(response)
      let allConcepts = response.data.concepts;

      // console.log('fetched concepts: ', allConcepts);

      console.log('fetched concepts')

      // run through all concepts' blocks and add last updated

      // sort by order
      //
      // allConcepts.sort(function(a, b) {
      //   if (a.order < b.order) return -1;
      //   if (a.order > b.order) return 1;
      //   return 0;
      // });

      // sort by last updated
      //
      allConcepts.sort(function(a, b) {
        if (a.updatedAt > b.updatedAt) return -1;
        if (a.updatedAt < b.updatedAt) return 1;
        return 0;
      });

      state.fetchedConcepts = true;
      state.concepts = allConcepts;

    } catch (error) { console.log(error) }
  },

  async deleteConcept(state, { conceptId }) {
    try {
      let response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/concepts/delete', { conceptId });
      this.commit('fetchConcepts')
    } catch (error) { console.log(error) }
  },

  async updateConcept(state, { conceptId, keyName, newValue, editingId }) {
    try {
      let response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/concepts/update', {
        conceptId,
        keyName,
        newValue
       });

      this.commit('stopEditing', {reason: 'success', editingId: editingId});

    } catch (error) { console.log(error) }
  },

  async updateBlock(state, { blockId, keyName, newValue, editingId }) {
    try {
      let response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/block/update', {
        blockId,
        keyName,
        newValue
       });

      this.commit('stopEditing', {reason: 'success', editingId: editingId});

    } catch (error) { console.log(error) }
  },

  async fetchBlocks (state) {
    try {
      const response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/blocks');
      let allBlocks = response.data.blocks;
      // console.log('fetched blocks: ', allBlocks);
      state.blocks = allBlocks;

    } catch (error) { console.log(error) }
  },

  async fetchAllBlocks (state) {
    try {
      var promises = state.userTrusts.map(userTrust => helpers.callServer('POST', userTrust.shorthand, state.baseTenantUrl + '/blocks').then(response => response.data.blocks));
      Promise.all(promises).then(results => {
          results = [].concat(...results)
          state.allBlocks = results;
      });
    } catch (error) { console.log(error) }
  },

  async fetchAllConcepts (state) {
    try {
      var promises = state.userTrusts.map(userTrust => helpers.callServer('POST', userTrust.shorthand, state.baseTenantUrl + '/concepts').then(response => {
        let resy = response.data.concepts;
        let concepts = resy.map(c => ({...c, group: userTrust.shorthand}));
        console.log(concepts)
        return concepts
      }));
      Promise.all(promises).then(results => {
          results = [].concat(...results)
          state.allConcepts = results;
      });
    } catch (error) { console.log(error) }
  },

  async createBlock(state, { blockObj }){
    try {
      this.commit('setSavingBlock', { reason: 'starting' });

      let response = await helpers.callServer('POST', state.activeTrust, state.baseTenantUrl + '/block/add', { newBlock: blockObj });

      this.commit('fetchConcepts')
      this.commit('fetchBlocks')
      this.commit('setSavingBlock', { reason: 'success' });

    } catch (e) {
      this.commit('setSavingBlock', { reason: 'error', message: e });
      console.error("Error adding document: ", e);
      this.errorMessage = e;
    }
  },

};

export default {
   state,
   getters,
   actions,
   mutations
}
